var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Detail Pasien Dirawat")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "card mb-3" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("Data Pasien"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-striped" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v("No. RM")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.Medrec))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("No. Registrasi")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.Regno))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Nama Pasien")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.Firstname))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Kategori")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.NmKategori))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Jenis Kelamin")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.gender))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Umur")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.umur))]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card mb-3" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("Keterangan"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-striped" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { attrs: { width: "20%" } }, [
                    _vm._v("Ruangan/Kelas"),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.ruang_kelas))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Kamar/Nomor")]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm.data_pasien.nokamar) +
                        " / " +
                        _vm._s(_vm.data_pasien.NoTTidur)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Asal Perawatan")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.NMPoli))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Waktu Masuk Perawatan")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.waktu_masuk))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("Lama Perawatan (Hari)")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.lama_rawat))]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [_vm._v("DPJP")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.data_pasien.NmDocRS))]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card mb-3" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("Rincian Biaya"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { attrs: { id: "table-biaya" } }, [
              _c("table", { staticClass: "table" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("tbody", [
                  _vm.data_pasien.bilRoom > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Ruangan Rawat")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilRoom)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilIrna > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Tindakan Ruangan")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilIrna)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilObat > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Pemakaian Obat/Apotik")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilObat)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilBhp > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Pemakaian BHP")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilBhp)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilLab > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Laboratorium")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilLab)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilRad > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Radiologi")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilRad)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilUgd > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Tindakan UGD")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilUgd)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilOp > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Tindakan Operasi")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilOp)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilFis > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Tindakan Fisioterapi")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilFis)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_pasien.bilVk > 0
                    ? _c("tr", [
                        _c("td", [_vm._v("Tindakan VK")]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              Intl.NumberFormat().format(
                                Math.round(_vm.data_pasien.bilVk)
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("tfoot", [
                  _c("tr", [
                    _c("th", [_vm._v("Uang Muka")]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          Intl.NumberFormat().format(
                            _vm.data_pasien.uangMuka > 0
                              ? Math.round(_vm.data_pasien.uangMuka)
                              : 0
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Total")]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          Intl.NumberFormat().format(
                            _vm.data_pasien.realisasi > 0
                              ? Math.round(_vm.data_pasien.realisasi)
                              : 0
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tindakan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Biaya")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card mb-3" }, [
      _c("div", { staticClass: "card-header text-white bg-primary" }, [
        _vm._v("Histori Pindah Kamar"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table-histori" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }